import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import NewSignature from './newSignatur'
import IconButton from '@material-ui/core/IconButton'
import {isEmpty, isUndefined} from 'lodash'
import { DeleteOutlined, EditOutlined, Add, VpnKeyOutlined, SwapHoriz } from '@material-ui/icons';
import DeleteSignatur from './deleteSignatur'
import IntlMessages from 'util/IntlMessages';
export default function SimpleMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelectSignatur = (signatur,e) => {
    if(e.stopPropagation) {
      handleClose()
      props.handleSelectSignatur(signatur)
    }
  }
  const handleDelete = (s) => {
    props.onDeleteSignatur(s)
  }

  return (
    <>
    {
      isUndefined(props.isMenuItem) ?
      <Button size="small"
          variant="contained"  onClick={handleClick}><IntlMessages id={"Insert.Signature"} /></Button> :
      <MenuItem onClick={handleClick}><IntlMessages id={"Insert.Signature"} /></MenuItem>
    }
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {
          isEmpty(props.signatures) ? '' : props.signatures.map((s,index) => {
            return <MenuItem key={index} onClick={(e) => handleSelectSignatur(s,e)}><div className='d-flex w-100 justify-content-between'>
              <span>
              {/* <Tooltip title={parseInt(s.SDefault) === 1 ? 'Ta bort primär' : 'Gör primär'} placement="right">
              <IconButton onClick={(e) => {
                e.stopPropagation()
                props.handleSetEditSignatureDefault(s, parseInt(s.SDefault) === 1 ? 0 : 1)
              } } size="small">
                {
                  parseInt(s.SDefault) === 1 ? <VpnKeyOutlined className='text-info'/> : <SwapHoriz color="primary"/>
                }
                
              </IconButton></Tooltip> */}
              <span className=''>{s.Name}</span>
              </span>
              {/* <div className='d-flex ml-3'>
                <Tooltip title="Ta bort signatur" placement="right">
              <IconButton onClick={(e) => {
                e.stopPropagation()
                props.handleSetEditSignatureOpen(true, s)
              } } size="small" color="primary">
                <EditOutlined/>
              </IconButton></Tooltip>
                <Tooltip title="Ta bort signatur" placement="right">
              <IconButton onClick={(e) => {
                e.stopPropagation()
                props.handleSetDeleteSignatureOpen(true, s)
              } } size="small" color="secondary">
                <DeleteOutlined/>
              </IconButton></Tooltip>
              </div> */}
              </div></MenuItem>
          })
        }
        {/* <MenuItem onClick={() => props.handleSetNewSignatureOpen(true)}><div className='d-flex w-100 justify-content-between'>
              <span>Ny signatur</span>
              <div className='d-flex'>
                <Add color="primary"/>
              </div>
              </div></MenuItem> */}
      </Menu>
    </>
  );
}